const GA4_ID = 'G-17BP7JQ61Y';
const ACTIONS = {
  phone: 'AW-847034928/aj4WCL6DofgcELD08pMD',
  email: 'AW-847034928/tWzbCMGDofgcELD08pMD',
  line: 'AW-847034928/BjyZCNzB7akdELD08pMD',
  form: 'AW-847034928/fdT8CLuDofgcELD08pMD',
  interaction: 'AW-847034928/j01HCMC5_IEdELD08pMD',
  engaged: 'AW-847034928/jcboCOnH9YEdELD08pMD',
};

function browserTag() {
  return typeof window !== 'undefined' ? window.gtag : undefined;
}

function send(gtag, name, parameters) {
  if (typeof gtag !== 'function') return;
  try {
    gtag('event', name, parameters);
  } catch {
    // Measurement must never interrupt the customer's contact action.
  }
}

export function trackContactClick(href, gtag = browserTag()) {
  const protocol = typeof href === 'string' ? href.trim().split(':')[0].toLowerCase() : '';
  const method = protocol === 'tel' ? 'phone' : protocol === 'mailto' ? 'email' : null;
  if (!method) return;
  send(gtag, 'conversion', { send_to: ACTIONS[method] });
  // Do not send link destinations, form values, or personal data to Analytics.
  send(gtag, 'contact_click', { send_to: GA4_ID, method });
}

// Call only after the inquiry has been successfully submitted.
export function trackFormSubmitted(gtag = browserTag()) {
  send(gtag, 'conversion', { send_to: ACTIONS.form });
  send(gtag, 'generate_lead', { send_to: GA4_ID, method: 'contact_form' });
}

// Fixed categories only: never send button text, form input, or link URLs.
export function trackWebsiteInteraction(kind, gtag = browserTag()) {
  // LINE has its own contact action; do not also count a generic interaction.
  if (kind === 'line') {
    send(gtag, 'conversion', { send_to: ACTIONS.line });
    send(gtag, 'contact_click', { send_to: GA4_ID, method: 'line' });
    return;
  }
  if (!['navigation', 'project_detail', 'blog', 'button', 'external_link', 'phone', 'email', 'line'].includes(kind)) return;
  send(gtag, 'conversion', { send_to: ACTIONS.interaction });
  send(gtag, 'website_interaction', { send_to: GA4_ID, interaction_type: kind });
}

export function trackEngagedVisit(gtag = browserTag()) {
  send(gtag, 'conversion', { send_to: ACTIONS.engaged });
  send(gtag, 'engaged_visit_10s', { send_to: GA4_ID });
}
